<template>
  <div class="setting_main_contents">
    <div class="setting_heading">
      <h1 class="setting_heading_title">
        {{ labelProperties.TAB_HEADER }}
      </h1>
      <p class="setting_heading_explain">
        {{ labelProperties.SUB_HEADER }}
      </p>
    </div>
    <div :class="{'overlay_setting':isLoadingData} ">
      <i :class="{'loadding_setting': isLoadingData}"></i>
    </div>
    <form @change="logChangeData()">
      <div class="setting_tab">
        <div class="setting_tab_nav">
          <ul class="setting_tab_nav_list">
            <li id="n1" class="setting_tab_nav_item is_active" @click.prevent="changeNavTab(FIRST_TAB)">
              <span class="setting_tab_nav_text">
                {{ labelProperties.FIRST_TAB.TAB_TITLE }}
              </span>
            </li>
            <li id="n2" class="setting_tab_nav_item" @click.prevent="changeNavTab(SECOND_TAB)">
              <span class="setting_tab_nav_text">
                {{ labelProperties.SECOND_TAB.TAB_TITLE }}
              </span>
            </li>
            <li id="n3" class="setting_tab_nav_item" @click.prevent="changeNavTab(THIRD_TAB)">
              <span class="setting_tab_nav_text">
                {{ labelProperties.THIRD_TAB.TAB_TITLE }}
              </span>
            </li>
          </ul>
        </div>
        <div v-if="navTab === FIRST_TAB" class="setting_tab_content">
          <div class="setting_tab_content_panel is_active">
            <div class="setting_content">
              <div class="setting_content_main">
                <h2 class="setting_content_title">
                  {{ labelProperties.FIRST_TAB.TAB_HEADER }}
                </h2>
                <div class="setting_unit" v-if="hp_renkei_entry === 1">
                  <p class="setting_unit_title">
                    {{ labelProperties.FIRST_TAB.ENTRY_SETTING.LABEL }}
                  </p>
                  <div class="setting_unit_item">
                    <label for="entryPageName" class="setting_unit_label">
                      <b>
                        {{ labelProperties.FIRST_TAB.ENTRY_SETTING.PAGE_TITLE }}
                      </b>
                    </label>
                    <div class="setting_unit_form">
                      <input
                          type="text"
                          class="setting_form_text"
                          id="entryPageName"
                          v-model="entryPageName"
                          :placeholder="labelProperties.FIRST_TAB.ENTRY_SETTING.PAGE_TITLE_PLACEHOLDER"
                          @change="validateEntryPageName()"
                      />
                      <h6 v-show="entryPageName.length > commonSettingsProperties.PAGE_TITLE_MAX_LENGTH" class="error-message">
                        {{ commonSettingsProperties.PAGE_TITLE_MAX_LENGTH + commonSettingsProperties.MESSAGE.MAX_LENGTH_CHARACTER }}
                      </h6>
                    </div>
                  </div>
                  <div class="setting_unit_item">
                    <label for="entryPageOverview" class="setting_unit_label">
                      <b>
                        {{ labelProperties.FIRST_TAB.ENTRY_SETTING.PAGE_OVERVIEW }}
                      </b>
                    </label>
                    <div class="setting_unit_form">
                      <textarea
                          class="setting_form_text"
                          id="entryPageOverview"
                          v-model="entryPageOverview"
                          :placeholder="labelProperties.FIRST_TAB.ENTRY_SETTING.PAGE_OVERVIEW_PLACEHOLDER"
                          @change="validateEntryPageOverview()"
                          rows="3"
                      />
                      <h6 v-show="entryPageOverview.length > commonSettingsProperties.PAGE_OVERVIEW_MAX_LENGTH" class="error-message">
                        {{ commonSettingsProperties.PAGE_OVERVIEW_MAX_LENGTH + commonSettingsProperties.MESSAGE.MAX_LENGTH_CHARACTER }}
                      </h6>
                    </div>
                  </div>
                  <div class="setting_unit_item">
                    <label for="entryURL" class="setting_unit_label">
                      <b>
                        {{ labelProperties.FIRST_TAB.ENTRY_SETTING.PAGE_URL_INPUT_TITLE }}
                      </b>
                    </label>
                    <div class="setting_unit_form">
                      <input
                          type="text"
                          class="setting_form_text"
                          id="entryURL"
                          v-model="entryURL"
                          :placeholder="labelProperties.FIRST_TAB.ENTRY_SETTING.PAGE_URL_PLACEHOLDER"
                          @change="validateEntryURL()"
                      />
                      <h6 v-show="entryURL.length > commonSettingsProperties.URL_MAX_LENGTH" class="error-message">
                        {{commonSettingsProperties.URL_MAX_LENGTH + commonSettingsProperties.MESSAGE.MAX_LENGTH_CHARACTER }}
                      </h6>
                      <h6 v-show="entryURL && !(entryURL.startsWith('http://') || entryURL.startsWith('https://'))" class="error-message">
                        {{ commonSettingsProperties.MESSAGE.WRONG_ENTRY_URL }}
                      </h6>
                    </div>
                  </div>
                  <div class="setting_unit_item">
                    <label for="entryCompletionURL" class="setting_unit_label">
                      <b>
                        {{ labelProperties.FIRST_TAB.ENTRY_SETTING.PAGE_COMPLETION_URL_INPUT_TITLE }}
                      </b>
                    </label>
                    <div class="setting_unit_form">
                      <input
                          type="text"
                          class="setting_form_text"
                          id="entryCompletionURL"
                          v-model="entryCompletionURL"
                          :placeholder="labelProperties.FIRST_TAB.ENTRY_SETTING.PAGE_COMPLETION_URL_PLACEHOLDER"
                          @change="validateEntryCompletionURL()"
                      />
                      <h6 v-show="entryCompletionURL.length > commonSettingsProperties.URL_MAX_LENGTH" class="error-message">
                        {{ commonSettingsProperties.URL_MAX_LENGTH + commonSettingsProperties.MESSAGE.MAX_LENGTH_CHARACTER }}
                      </h6>
                      <h6 v-show="entryCompletionURL && !(entryCompletionURL.startsWith('http://') || entryCompletionURL.startsWith('https://'))" class="error-message">
                        {{ commonSettingsProperties.MESSAGE.WRONG_ENTRY_COMPLETION_URL }}
                      </h6>
                    </div>
                  </div>
                  <div class="setting_unit_item">
                    <p class="setting_unit_label">
                      {{ labelProperties.FIRST_TAB.ENTRY_SETTING.PUBLISHING_SETTINGS_RADIO_TITLE }}
                    </p>
                    <div class="setting_unit_form">
                      <label class="setting_form_radio_label">
                        <input
                            type="radio"
                            v-model="commonSettings.entryPublic"
                            value="true"
                            id="isSearchPublic"
                            checked="checked"
                        />
                        <label for="isSearchPublic" class="setting_form_radio_text">
                          {{ labelProperties.FIRST_TAB.PUBLIC_OPTION }}
                        </label>
                      </label>
                      <label class="setting_form_radio_label">
                        <input
                            type="radio"
                            v-model="commonSettings.entryPublic"
                            value="false"
                            id="isSearchPrivate"
                        />
                        <label for="isSearchPrivate" class="setting_form_radio_text">
                          {{ labelProperties.FIRST_TAB.PRIVATE_OPTION }}
                        </label>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="setting_unit" v-if="hp_renkei_job === 1">
                  <p class="setting_unit_title">
                    {{ labelProperties.FIRST_TAB.JOB_SETTING.LABEL }}
                  </p>
                  <div class="setting_unit_item">
                    <label for="jobSearchPageName" class="setting_unit_label">
                      {{ labelProperties.FIRST_TAB.JOB_SETTING.PAGE_TITLE }}
                    </label>
                    <div class="setting_unit_form">
                      <input
                          type="text"
                          class="setting_form_text"
                          id="jobSearchPageName"
                          v-model="jobSearchPageName"
                          :placeholder="labelProperties.FIRST_TAB.JOB_SETTING.PAGE_TITLE_PLACEHOLDER"
                          @change="validateJobSearchPageName()"
                      />
                      <h6 v-show="jobSearchPageName.length > commonSettingsProperties.PAGE_TITLE_MAX_LENGTH" class="error-message">
                        {{ commonSettingsProperties.PAGE_TITLE_MAX_LENGTH + commonSettingsProperties.MESSAGE.MAX_LENGTH_CHARACTER }}
                      </h6>
                    </div>
                  </div>
                  <div class="setting_unit_item">
                    <label for="jobPageOverview" class="setting_unit_label">
                      <b>
                        {{ labelProperties.FIRST_TAB.JOB_SETTING.PAGE_OVERVIEW }}
                      </b>
                    </label>
                    <div class="setting_unit_form">
                      <textarea
                          class="setting_form_text"
                          id="jobPageOverview"
                          v-model="jobPageOverview"
                          :placeholder="labelProperties.FIRST_TAB.JOB_SETTING.PAGE_OVERVIEW_PLACEHOLDER"
                          @change="validateJobSearchPageOverview()"
                          rows="3"
                      />
                      <h6 v-show="jobPageOverview.length > commonSettingsProperties.PAGE_OVERVIEW_MAX_LENGTH" class="error-message">
                        {{ commonSettingsProperties.PAGE_OVERVIEW_MAX_LENGTH + commonSettingsProperties.MESSAGE.MAX_LENGTH_CHARACTER }}
                      </h6>
                    </div>
                  </div>
                  <div class="setting_unit_item">
                    <div class="setting_unit_label">
                      <label for="jobSearchURL">
                        {{ labelProperties.FIRST_TAB.JOB_SETTING.PAGE_URL_INPUT_TITLE }}
                      </label>
                    </div>
                    <div class="setting_unit_form">
                      <input
                          type="text"
                          class="setting_form_text"
                          id="jobSearchURL"
                          v-model="jobSearchURL"
                          :placeholder="labelProperties.FIRST_TAB.JOB_SETTING.PAGE_URL_PLACEHOLDER"
                          @change="validateJobSearchURL()"
                      />
                      <h6 v-show="jobSearchURL.length > commonSettingsProperties.URL_MAX_LENGTH" class="error-message">
                        {{ commonSettingsProperties.URL_MAX_LENGTH + commonSettingsProperties.MESSAGE.MAX_LENGTH_CHARACTER }}
                      </h6>
                      <h6 v-show="jobSearchURL && !(jobSearchURL.startsWith('http://') || jobSearchURL.startsWith('https://'))" class="error-message">
                        {{ commonSettingsProperties.MESSAGE.WRONG_JOB_SEARCH_URL }}
                      </h6>
                    </div>
                  </div>
                  <div class="setting_unit_item">
                    <div class="setting_unit_label">
                      <label for="jobInquiryUrl">
                        {{ labelProperties.FIRST_TAB.JOB_SETTING.JOB_INQUIRY_URL_INPUT_TITLE }}
                      </label>
                    </div>
                    <div class="setting_unit_form">
                      <input
                          type="text"
                          class="setting_form_text"
                          id="jobInquiryUrl"
                          v-model="jobInquiryUrl"
                          :placeholder="labelProperties.FIRST_TAB.JOB_SETTING.JOB_INQUIRY_URL_PLACEHOLDER"
                          @change="validateJobInquiryUrl()"
                      />
                      <h6 v-show="jobInquiryUrl.length > commonSettingsProperties.URL_MAX_LENGTH" class="error-message">
                        {{ commonSettingsProperties.URL_MAX_LENGTH + commonSettingsProperties.MESSAGE.MAX_LENGTH_CHARACTER }}
                      </h6>
                      <h6 v-show="jobInquiryUrl && !(jobInquiryUrl.startsWith('http://') || jobInquiryUrl.startsWith('https://'))" class="error-message">
                        {{ commonSettingsProperties.MESSAGE.WRONG_JOB_INQUIRY_URL }}
                      </h6>
                    </div>
                  </div>
                  <div class="setting_unit_item">
                    <p class="setting_unit_label">
                      {{ labelProperties.FIRST_TAB.JOB_SETTING.PUBLISHING_SETTINGS_RADIO_TITLE }}
                    </p>
                    <div class="setting_unit_form">
                      <label class="setting_form_radio_label">
                        <input
                            type="radio"
                            value="true"
                            id="isDetailsPublic"
                            checked="checked"
                            v-model="commonSettings.jobSearchPublic"
                        />
                        <label for="isDetailsPublic" class="setting_form_radio_text">
                          {{ labelProperties.FIRST_TAB.PUBLIC_OPTION }}
                        </label>
                      </label>
                      <label class="setting_form_radio_label">
                        <input
                            type="radio"
                            value="false"
                            id="unIsDetailsPublic"
                            v-model="commonSettings.jobSearchPublic"
                        />
                        <label for="unIsDetailsPublic" class="setting_form_radio_text">
                          {{ labelProperties.FIRST_TAB.PRIVATE_OPTION }}
                        </label>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="navTab === SECOND_TAB" class="setting_tab_content">
          <div class="setting_tab_content_panel is_active">
            <div class="setting_content">
              <div class="setting_content_main">
                <h2 class="setting_content_title">
                  {{ labelProperties.SECOND_TAB.TAB_HEADER }}
                </h2>
                <div class="setting_unit"
                    v-for="(accessAnalysisSetting, index) in accessAnalysisSettings" :key="index">
                  <p class="setting_unit_title">
                    {{ labelProperties.SECOND_TAB.SUB_HEADER }}
                    {{ index + 1 }}
                  </p>
                  <div class="setting_unit_item">
                    <p class="setting_unit_label">
                      {{ labelProperties.SECOND_TAB.ACCESS_ANALYSIS_TEXTAREA_TITLE }}
                    </p>
                    <div class="setting_unit_form">
                      <textarea
                          class="setting_form_textarea"
                          v-model="accessAnalysisSetting.accessAnalysis"
                          :placeholder="labelProperties.SECOND_TAB.ACCESS_ANALYSIS_PLACEHOLDER"
                          @change="onValidateAccessAnalysis()">
                      </textarea>
                      <span v-show="accessAnalysisOverLength.includes(index)" class="error-message">
                        {{ commonSettingsProperties.ACCESS_ANALYSIS_MAX_CHARACTER }}
                        {{ commonSettingsProperties.MESSAGE.MAX_LENGTH_CHARACTER }}
                      </span>
                      <span v-show="accessAnalysisWrongFormat.includes(index)" class="error-message setting_white_space_break">{{ commonSettingsProperties.MESSAGE.WRONG_FORMAT }}</span>
                    </div>
                  </div>
                  <div class="setting_unit_item">
                    <p class="setting_unit_label">
                      {{ labelProperties.SECOND_TAB.POSITION_RADIO_TITLE }}
                    </p>
                    <div class="setting_unit_form">
                      <label class="setting_form_radio_label">
                        <input
                            v-model="accessAnalysisSetting.introductionPoint"
                            type="radio"
                            value="0"
                            :id="'TAB_HEADER' + index"
                        />
                        <label :for="'TAB_HEADER' + index" class="setting_form_radio_text">
                          {{ labelProperties.SECOND_TAB.POSITION_HEADER_OPTION }}
                        </label>
                      </label>
                      <label class="setting_form_radio_label">
                        <input
                            v-model="accessAnalysisSetting.introductionPoint"
                            type="radio"
                            value="1"
                            :id="'body' + index"
                        />
                        <label :for="'body' + index" class="setting_form_radio_text">
                          {{ labelProperties.SECOND_TAB.POSITION_BODY_OPTION }}
                        </label>
                      </label>
                      <p class="setting_unit_annotation">
                        {{ labelProperties.SECOND_TAB.POSITION_NOTICE }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="setting_unit_add">
                  <a class="setting_unit_add_btn" v-on:click="handleAddAccessAnalysis">
                    {{ labelProperties.SECOND_TAB.ADD_ANALYSIS_LINK_TITLE }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="navTab === THIRD_TAB" class="setting_tab_content">
          <div class="setting_tab_content_panel is_active">
            <div class="setting_content">
              <div class="setting_content_main">
                <h2 class="setting_content_title">
                  {{ labelProperties.THIRD_TAB.TAB_HEADER }}
                </h2>
                <p class="setting_content_explain">
                  {{ labelProperties.THIRD_TAB.FIRST_SUB_HEADER }}
                  <br/>
                  {{ labelProperties.THIRD_TAB.SECOND_SUB_HEADER }}
                  <br/>
                  {{ labelProperties.THIRD_TAB.THIRD_SUB_HEADER }}
                </p>
                <div class="setting_unit" v-if="hp_renkei_entry === 1">
                  <div class="setting_unit_title_wrapper">
                    <p class="setting_unit_title">
                      {{ labelProperties.THIRD_TAB.ENTRY_EMBED_CODE_TITLE }}
                    </p>
                    <button class="setting_btn_secondary setting_btn_medium"
                        @click.prevent="copyEmbedCode('entryEmbedCode')">
                      {{ labelProperties.THIRD_TAB.COPY_IFRAME_BUTTON }}
                    </button>
                  </div>
                  <textarea
                      id="entryEmbedCode"
                      v-model="entryEmbedCode"
                      class="setting_form_textarea"
                      rows="3"
                      no-resize
                      plaintext
                      readonly
                  >
                  </textarea>
                </div>
                <div class="setting_unit" v-if="hp_renkei_job === 1">
                  <div class="setting_unit_title_wrapper">
                    <label class="setting_unit_title">
                      {{ labelProperties.THIRD_TAB.JOB_EMBED_CODE_TITLE }}
                    </label>
                    <button size="sm" class="setting_btn_secondary setting_btn_medium"
                        @click.prevent="copyEmbedCode('jobEmbedCode')">
                      {{ labelProperties.THIRD_TAB.COPY_IFRAME_BUTTON }}
                    </button>
                  </div>
                  <textarea
                      id="jobEmbedCode"
                      v-model="jobEmbedCode"
                      class="setting_form_textarea"
                      rows="3"
                      no-resize
                      plaintext
                      readonly
                  >
                  </textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="setting_footer">
      <button class="setting_btn_outline"
          @click="cancelChangeCommonSettings()">
        {{ labelProperties.CANCEL_BUTTON }}
      </button>
      <button class="setting_btn_primary" :class="{'setting_btn_disabled': isDisableSaveBtn}"
          @click="saveCommonSettings()">
        {{ labelProperties.SAVE_BUTTON }}
      </button>
      <div class="setting_footer_balloon" v-if="unSavedData">
        {{ entryMessageProperties.SAVE_CHANGE_DATA }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import commonSettingsService from "../../services/CommonSettingsService";
import commonSettingsProperties from "../../properties/common_screen/common-settings.json";
import labelProperties from "../../properties/common_screen/commonsetting-labels.json";
import generalService from "../../services/GeneralService";
import entryMessageProperties from "../../properties/entry_screen/entry_screen.json";
import generalLabelProperties from "../../properties/general_page/generalpage-labels.json";
import {Encrypt} from "@/plugins/cryptojs";
import * as generalMessages from "../../properties/general_page/generalpage.json";

Vue.use(VueToast);

const ENTRY_TEXT = "entry";
const JOB_TEXT = "job";
const DISPATCH_JOB_TEXT = "dispatch_job";

const FIRST_TAB = 1;
const SECOND_TAB = 2;
const THIRD_TAB = 3;
const START_PAGE_TITLE = generalLabelProperties.START_TITLE_PAGE + " > " + commonSettingsProperties.COMMON_SETTING_PAGE_TITLE + " > ";

export default {
  name: "CommonSettings",
  props: [
    "groupName",
    "hp_renkei_entry",
    "hp_renkei_job",
    "is_plan_dispatch_basic",
    "unSavedData",
    "userId",
    "token"
  ],
  data: function () {
    return {
      commonSettingsProperties: commonSettingsProperties,
      entryMessageProperties: entryMessageProperties,
      generalLabelProperties: generalLabelProperties,
      labelProperties: labelProperties,
      commonSettings: {
        entryPageName: "",
        jobSearchPageName: "",
        entryURL: "",
        entryCompletionURL: "",
        jobSearchURL: "",
        entryPublic: false,
        jobSearchPublic: false,
        dispatchPublic: false,
        jobInquiryUrl: "",
        entryEmbedCode: "",
        jobEmbedCode: "",
        accessAnalysisSettings: [],
        entryPageOverview: "",
        jobPageOverview: ""
      },
      entryPageName: "",
      entryPageNameError: false,
      jobSearchPageName: "",
      jobSearchPageNameError: false,
      entryURL: '',
      entryURLError: false,
      entryCompletionURL: '',
      entryCompletionURLError: false,
      jobSearchURL: '',
      jobSearchURLError: false,
      jobInquiryUrl: '',
      jobInquiryUrlError: false,
      entryEmbedCode: "",
      jobEmbedCode: "",
      encryptEntryCode: "",
      encryptJobCode: "",
      encryptDispatchJobCode: "",
      entryPageOverview: "",
      entryPageOverviewError: false,
      jobPageOverview: "",
      jobPageOverviewError: false,
      accessAnalysisSettings: [
        {
          accessAnalysis: "",
          introductionPoint: 0,
        },
      ],
      iframeAttributes: "",
      accessAnalysisOverLength: [],
      accessAnalysisWrongFormat: [],
      navTab: FIRST_TAB,
      log: {
        info: {},
      },
      isLoadingData: true,
      FIRST_TAB: FIRST_TAB,
      SECOND_TAB: SECOND_TAB,
      THIRD_TAB: THIRD_TAB,
      isDisableSaveBtn: false,
    };
  },
  watch: {
    navTab() {
      this.checkDisableSaveBtn();
    },

    accessAnalysisOverLength() {
      this.checkDisableSaveBtn();
    },

    accessAnalysisWrongFormat() {
      this.checkDisableSaveBtn();
    },

    entryPageNameError() {
      this.checkDisableSaveBtn();
    },

    entryPageOverviewError() {
      this.checkDisableSaveBtn();
    },

    jobPageOverviewError() {
      this.checkDisableSaveBtn();
    },

    jobSearchPageNameError() {
      this.checkDisableSaveBtn();
    },

    entryURLError() {
      this.checkDisableSaveBtn();
    },

    entryCompletionURLError() {
      this.checkDisableSaveBtn();
    },

    jobSearchURLError() {
      this.checkDisableSaveBtn();
    },

    jobInquiryUrlError() {
      this.checkDisableSaveBtn();
    }
  },
  async created() {
    document.title = START_PAGE_TITLE + labelProperties.FIRST_TAB.TAB_TITLE;
    this.log.groupName = this.groupName;
    this.log.hash = generalService.createHashCode(15);
    this.log.info.action = "Load data " + generalLabelProperties.FIRST_TAB;
    this.log.info.path = window.location.href;
    this.log.info.userId = this.userId;
    await this.setLogger(this.log);
    this.encryptEntryCode = encodeURIComponent(Encrypt(this.groupName + ENTRY_TEXT));
    this.encryptJobCode = encodeURIComponent(Encrypt(this.groupName + JOB_TEXT));
    this.encryptDispatchJobCode = encodeURIComponent(Encrypt(this.groupName + DISPATCH_JOB_TEXT));
    await this.getIframeAttribute();
    await this.getCommonSetting(this.log.hash);
    // commnet out
    this.isLoadingData = false;
  },
  updated() {
    this.$eventBus.$emit("commonSetting", this.commonSettings);
  },
  methods: {
    logChangeData() {
      this.$eventBus.$emit("unSaved", true);
    },

    async cancelChangeCommonSettings() {
      this.isLoadingData = true;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = `Menu ${generalLabelProperties.FIRST_TAB} Click button ${labelProperties.CANCEL_BUTTON}`;
      await this.setLogger(this.log);
      await this.getCommonSetting(this.log.hash);
      this.isLoadingData = false;
      this.onValidateAccessAnalysis();
      this.$eventBus.$emit("unSaved", false);
    },

    handleOutputData() {
      if (!this.entryPageNameError) {
        this.commonSettings.entryPageName = this.entryPageName;
      }

      if (!this.entryPageOverviewError) {
        this.commonSettings.entryPageOverview = this.entryPageOverview;
      }

      if (!this.jobSearchPageNameError) {
        this.commonSettings.jobSearchPageName = this.jobSearchPageName;
      }

      if (!this.jobPageOverviewError) {
        this.commonSettings.jobPageOverview = this.jobPageOverview;
      }

      if (!this.entryURLError) {
        this.commonSettings.entryURL = this.entryURL;
      }

      if (!this.entryCompletionURLError) {
        this.commonSettings.entryCompletionURL = this.entryCompletionURL;
      }

      if (!this.jobSearchURLError) {
        this.commonSettings.jobSearchURL = this.jobSearchURL;
      }

      if (!this.jobInquiryUrlError) {
        this.commonSettings.jobInquiryUrl = this.jobInquiryUrl;
      }
      this.commonSettings.entryEmbedCode = !this.commonSettings.entryEmbedCode ? this.encryptEntryCode : this.commonSettings.entryEmbedCode;
      this.commonSettings.jobEmbedCode = !this.commonSettings.jobEmbedCode ? this.encryptJobCode : this.commonSettings.jobEmbedCode;
      if (this.accessAnalysisOverLength.length === 0 && this.accessAnalysisWrongFormat.length === 0) {
        this.commonSettings.accessAnalysisSettings = [];
        this.accessAnalysisSettings.forEach(analysis => {
          this.commonSettings.accessAnalysisSettings.push(analysis);
        })
      }

      if(this.hp_renkei_entry !== 1) {
        this.commonSettings.entryPublic = false;
      }

      if(this.hp_renkei_job !== 1) {
        this.commonSettings.jobSearchPublic = false;
      }

      this.commonSettings.dispatchPublic = this.is_plan_dispatch_basic === 1;
    },

    async saveCommonSettings() {
      this.isLoadingData = true;
      Vue.$toast.clear();
      await this.handleOutputData();
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabelProperties.FIRST_TAB + " Click button " + labelProperties.SAVE_BUTTON;
      this.log.info.paras = this.commonSettings;
      await this.setLogger(this.log);
      delete this.log.info.paras;
      await commonSettingsService.saveCommonSetting(this.commonSettings, this.log.hash, this.token).then(response => {
        this.commonSettings = response.data;
        this.handleInputData();
        this.$eventBus.$emit("unSaved", false);
        Vue.$toast.success(
            this.commonSettingsProperties.MESSAGE.CREATED_SUCCESSFUL, {
              position: "bottom-right",
              duration: 3000,
            }
        );
      }).catch((e) => {
        Vue.$toast.error(generalMessages.ERROR_SAVE_DATA, {
            position: "bottom-right",
            duration: 3000,
          }
        );
        console.log(e);
      }).finally(() => {
        this.isLoadingData = false;
      });
    },

    handleInputData() {
      this.entryURL = this.commonSettings.entryURL ? this.commonSettings.entryURL : "";
      this.entryCompletionURL = this.commonSettings.entryCompletionURL ? this.commonSettings.entryCompletionURL : "";
      this.jobSearchURL = this.commonSettings.jobSearchURL ? this.commonSettings.jobSearchURL : "";
      this.jobInquiryUrl = this.commonSettings.jobInquiryUrl ? this.commonSettings.jobInquiryUrl : "";
      this.entryPageName = this.commonSettings.entryPageName ? this.commonSettings.entryPageName : "";
      this.entryPageOverview = this.commonSettings.entryPageOverview ? this.commonSettings.entryPageOverview : "";
      this.jobSearchPageName = this.commonSettings.jobSearchPageName ? this.commonSettings.jobSearchPageName : "";
      this.jobPageOverview = this.commonSettings.jobPageOverview ? this.commonSettings.jobPageOverview : "";
      
      if(this.commonSettings.entryPageName){
        this.$eventBus.$emit("entryName", this.commonSettings.entryPageName);
      }
      if(this.commonSettings.entryPageOverview){
        this.$eventBus.$emit("entryOverview", this.commonSettings.entryPageOverview);
      }
      if (this.commonSettings.jobSearchPageName) {
        this.$eventBus.$emit("jobPageName", this.commonSettings.jobSearchPageName);
      }
      if(this.commonSettings.jobPageOverview){
        this.$eventBus.$emit("jobOverview", this.commonSettings.jobPageOverview);
      }
      if (this.commonSettings.accessAnalysisSettings.length === 0) {
        this.refreshAccessAnalysisSetting();
      } else {
        this.accessAnalysisSettings = [];
        for (let i = 0; i < this.commonSettings.accessAnalysisSettings.length; i++) {
          let analysis = {
            accessAnalysis: this.commonSettings.accessAnalysisSettings[i].accessAnalysis,
            id: this.commonSettings.accessAnalysisSettings[i].id,
            introductionPoint: this.commonSettings.accessAnalysisSettings[i].introductionPoint,
          }

          this.accessAnalysisSettings.push(analysis);
        }
      }

      this.validateEntryURL();
      this.validateEntryCompletionURL();
      this.validateEntryPageName();
      this.validateEntryPageOverview()
      this.validateJobInquiryUrl();
      this.validateJobSearchPageName();
      this.validateJobSearchPageOverview();
      this.validateJobSearchURL();
      this.onValidateAccessAnalysis();
    },

    async getCommonSetting(hash) {
      await commonSettingsService.getCommonSetting(hash).then(async response => {
        if (response && response.data.id != null) {
          if(this.hp_renkei_entry !== 1) {
            response.data.entryPublic = false;
          }

          if(this.hp_renkei_job !== 1) {
            response.data.jobSearchPublic = false;
          }
          response.data.dispatchPublic = this.is_plan_dispatch_basic === 1;

          await this.updateCommonSettingControl(response.data, hash);
        } else {
          this.commonSettings = response.data;
          this.handleInputData();
          this.commonSettings = {
            entryPublic: this.hp_renkei_entry === 1,
            jobSearchPublic: this.hp_renkei_job === 1,
            dispatchPublic: this.is_plan_dispatch_basic === 1,
          };
        }
        let scriptSetStyle = '<script type="text/javascript"> \n' +
          '   window.addEventListener("message", (e) => { \n'+
          '      let iframe = document.getElementById("hp_iframe");\n' +
          '      if(!iframe) return;\n' +
          '      let eventName = e.data[0];\n'+
          '      let data = e.data[1];\n'+
          '      if (iframe.contentWindow === e.source){\n'+
          '         if (eventName === "resized"){\n'+
          '            iframe.scrolling = "no";\n'+
          '            iframe.frameborder = "no";\n'+
          '            iframe.style.height = data.height + "px";\n'+
          '         }\n'+
          '         if (eventName === "onTopIframe"){\n'+
          '            window.scrollTo(0, iframe.offsetTop);\n'+
          '         }\n'+
          '      }\n'+
          '}, false);\n'+
          '</' + 'script>';

        this.entryEmbedCode = scriptSetStyle + '\n' + '<iframe id="hp_iframe" src="' + window.location.origin + "/?c=" + (!this.commonSettings.entryEmbedCode ? this.encryptEntryCode : this.commonSettings.entryEmbedCode) + '"' + this.iframeAttributes + '></iframe>';
        this.jobEmbedCode = scriptSetStyle + '\n' + '<iframe id="hp_iframe" src="' + window.location.origin + "/?c=" + (!this.commonSettings.jobEmbedCode ? this.encryptJobCode : this.commonSettings.jobEmbedCode) + '"' + this.iframeAttributes + '></iframe>';
      }).catch((e) => {
        console.log(e);
        this.refreshAccessAnalysisSetting();
        this.entryEmbedCode = "";
        this.jobEmbedCode = "";
      });
    },

    async updateCommonSettingControl(commonSettings, hash) {
      this.isLoadingData = true;
      await commonSettingsService.saveCommonSetting(commonSettings, hash, this.token).then(response => {
        this.commonSettings = response.data;
        this.handleInputData();
      }).catch((e) => {
        console.log(e);
      }).finally(() => {
        this.isLoadingData = false;
      });
    },

    refreshAccessAnalysisSetting() {
      this.accessAnalysisSettings = [
        {
          accessAnalysis: "",
          introductionPoint: 0,
          commonSetting: {},
        },
      ];
    },

    onValidateAccessAnalysis() {
      const accessAnalysisMaxLength = this.commonSettingsProperties.ACCESS_ANALYSIS_MAX_CHARACTER;
      for (let i = 0; i < this.accessAnalysisSettings.length; i++) {
        const accessAnalysisIndex = this.accessAnalysisSettings[i];
        this.checkIncludeScriptTag(i, accessAnalysisIndex.accessAnalysis);
        this.checkLength(i, accessAnalysisIndex, accessAnalysisMaxLength);
      }
    },

    checkIncludeScriptTag(index, accessAnalysis) {
      if (accessAnalysis && !this.validateScriptInput(accessAnalysis)) {
        if (this.accessAnalysisWrongFormat.includes(index)) {
          return;
        }

        this.accessAnalysisWrongFormat.push(index);
      } else {
        const indexOfAccessAnalysis = this.accessAnalysisWrongFormat.indexOf(index);
        if (indexOfAccessAnalysis !== -1) {
          this.accessAnalysisWrongFormat.splice(indexOfAccessAnalysis, 1);
        }
      }
    },

    validateScriptInput(script){
      const regexOpenClosedTag = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/;
      const regexSelfClosedTag = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*\/>/;
      const regexOnlyOneTag = /<([a-z]+)(?=[\s>])(?:[^>=]|='[^']*'|="[^"]*"|=[^'"\s]*)*\s?\/?>/gi;
      if (!regexOpenClosedTag.test(script.replace(/\n/g, "")) && !regexSelfClosedTag.test(script.replace(/\n/g, ""))) {
        return false;
      }
      let scriptTags = script.match(regexOnlyOneTag);
      if ((!Array.isArray(scriptTags) || scriptTags.length !== 1) && !this.isValidateOnlyOneTag(script)) {
        return false;
      }

      return true;
    },

    isValidateOnlyOneTag(str) {
      let div = document.createElement('div');
      div.innerHTML = str.trim();
      return div.childElementCount === 1;
    },

    checkLength(index, accessAnalysisIndex, accessAnalysisMaxLength) {
      if (accessAnalysisIndex && accessAnalysisIndex.accessAnalysis.length > accessAnalysisMaxLength) {
        if (this.accessAnalysisOverLength.includes(index)) {
          return;
        }

        this.accessAnalysisOverLength.push(index);
      } else {
        const indexOfAccessAnalysis = this.accessAnalysisOverLength.indexOf(index);
        if (indexOfAccessAnalysis !== -1) {
          this.accessAnalysisOverLength.splice(indexOfAccessAnalysis, 1);
        }
      }
    },

    handleAddAccessAnalysis() {
      let newAccessAnalysisSetting = {
        accessAnalysis: "",
        introductionPoint: 0,
        commonSetting: {},
      };

      this.accessAnalysisSettings.push(newAccessAnalysisSetting);
    },

    async getIframeAttribute() {
      if (commonSettingsProperties.IFRAME.STYLE) {
        this.iframeAttributes += ' style="' + commonSettingsProperties.IFRAME.STYLE + '"';
      }

      if (commonSettingsProperties.IFRAME.ALLOW_FULL_SCREEN) {
        this.iframeAttributes += ' allowfullscreen="' + commonSettingsProperties.IFRAME.ALLOW_FULL_SCREEN + '"';
      }

      if (commonSettingsProperties.IFRAME.LOADING) {
        this.iframeAttributes += ' loading="' + commonSettingsProperties.IFRAME.LOADING + '" ';
      }
    },

    copyEmbedCode(type) {
      let embedCode = document.querySelector("#" + type);
      embedCode.setAttribute("type", "text");
      embedCode.select();
      document.execCommand("copy");
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabelProperties.FIRST_TAB + " - Tab " + labelProperties.THIRD_TAB.TAB_TITLE + " - Click Button " + labelProperties.THIRD_TAB.COPY_IFRAME_BUTTON;
      this.setLogger(this.log);
    },

    checkDisableSaveBtn() {
      this.isDisableSaveBtn = (this.navTab === SECOND_TAB && (this.accessAnalysisOverLength.length > 0 || this.accessAnalysisWrongFormat.length > 0)) || (this.navTab === FIRST_TAB && (this.entryPageNameError || this.jobInquiryUrlError || this.jobSearchURLError || this.jobSearchPageNameError || this.entryURLError || this.entryCompletionURLError || this.entryPageOverviewError || this.jobPageOverviewError));
    },

    changeNavTab(navTab) {
      document.getElementById("n" + this.navTab).classList.remove("is_active");
      this.navTab = navTab;
      document.getElementById("n" + navTab).classList.add("is_active");
      this.log.hash = generalService.createHashCode(15);
      const logPreMessage = `Menu ${generalLabelProperties.FIRST_TAB} - Click tab `;

      if (navTab === FIRST_TAB) {
        document.title = START_PAGE_TITLE + labelProperties.FIRST_TAB.TAB_TITLE;
        this.log.info.action = logPreMessage + labelProperties.FIRST_TAB.TAB_TITLE;
      } else if (navTab === SECOND_TAB) {
        document.title = START_PAGE_TITLE + labelProperties.SECOND_TAB.TAB_TITLE;
        this.log.info.action = logPreMessage + labelProperties.SECOND_TAB.TAB_TITLE;
      } else {
        document.title = START_PAGE_TITLE + labelProperties.THIRD_TAB.TAB_TITLE;
        this.log.info.action = logPreMessage + labelProperties.THIRD_TAB.TAB_TITLE;
      }

      this.setLogger(this.log);
    },

    async setLogger(loggerData) {
      this.logs = loggerData;
      await generalService.sendLogger(this.logs.hash, this.logs.info.path, this.logs).then((response) => {
        if (response.status === 200) {
          return true;
        }
      }).catch((e) => {
        console.log(e);
        return false;
      });
    },

    validateEntryPageName(){
      this.entryPageNameError = this.entryPageName.length > commonSettingsProperties.PAGE_TITLE_MAX_LENGTH;
    },

    validateEntryPageOverview(){
      this.entryPageOverviewError = this.entryPageOverview.length > commonSettingsProperties.PAGE_OVERVIEW_MAX_LENGTH;
    },

    validateEntryURL(){
      this.entryURLError = this.entryURL.length > commonSettingsProperties.URL_MAX_LENGTH || (this.entryURL && !(this.entryURL.startsWith('http://') || this.entryURL.startsWith('https://')));
    },

    validateEntryCompletionURL(){
      this.entryCompletionURLError = this.entryCompletionURL.length > commonSettingsProperties.URL_MAX_LENGTH || (this.entryCompletionURL && !(this.entryCompletionURL.startsWith('http://') || this.entryCompletionURL.startsWith('https://')));
    },

    validateJobSearchPageName(){
      this.jobSearchPageNameError = this.jobSearchPageName.length > commonSettingsProperties.PAGE_TITLE_MAX_LENGTH;
    },

    validateJobSearchPageOverview(){
      this.jobPageOverviewError = this.jobPageOverview.length > commonSettingsProperties.PAGE_OVERVIEW_MAX_LENGTH;
    },

    validateJobSearchURL(){
      this.jobSearchURLError = this.jobSearchURL.length > commonSettingsProperties.URL_MAX_LENGTH || (this.jobSearchURL && !(this.jobSearchURL.startsWith('http://') || this.jobSearchURL.startsWith('https://')));
    },

    validateJobInquiryUrl(){
      this.jobInquiryUrlError = this.jobInquiryUrl.length > commonSettingsProperties.URL_MAX_LENGTH || (this.jobInquiryUrl && !(this.jobInquiryUrl.startsWith('http://') || this.jobInquiryUrl.startsWith('https://')));
    },
  },
};
</script>

<style>
#entryEmbedCode,
#jobEmbedCode {
  border: 1px solid #ced4da !important;
}

.error-message {
  color: red;
  font-size: 15px;
}

.setting_white_space_break {
  white-space: break-spaces;
}
</style>

